<div class="topbar">
  <p>Aviso sobre facturación</p>
</div>
<div class="rendition-finish-movements-container">
  <div class="msg-success">
    <p *ngIf="!isOnlyInvoices">
      El monto total de facturas y el sobrefacturado quedaron desactualizado.
      Modifique los comprobantes
    </p>
    <p *ngIf="isOnlyInvoices">
      Tiene un monto sobrefacturado desactualizado. Modifique
      los comprobantes
    </p>
  </div>
  <div class="buttons">
    <qr-button
      class="print"
      [config]="buttonInvoices"
      (click)="onAction()"
    ></qr-button>
  </div>
</div>
